import React, { Component } from "react";
import { Layout, Menu, Dropdown, Avatar, Checkbox } from "antd";

import { FormattedMessage } from "react-intl";

import { getGreeting } from "../../helpers/utilities";

import { UserOutlined } from "@ant-design/icons";

import AppContext from "../../AppContext";


const { Header } = Layout;

export class TopbarSalutation extends Component {
  static contextType = AppContext;

  render() {
    const displayInfoMessages = (
      <div className="topbarInfoMessages">
        {this.context?.documents && this.props?.notifications ? (
          <FormattedMessage
            id={`You have {docs} new document${
              this.context?.documents > 1 ? "s" : ""
            } and {notifications} new notification${this.props?.notifications > 1 ? "s" : ""} to review.`}
            defaultMessage={`You have {docs} new document${
              this.context?.documents > 1 ? "s" : ""
            } and {notifications} new notification${this.props?.notifications > 1 ? "s" : ""} to review.`}
            values={{
              docs: this.context?.documents,
              notifications: this.props?.notifications,
            }}
          />
        ) : this.context?.documents ? (
          <FormattedMessage
            id={`You have {docs} new document${this.context?.documents > 1 ? "s" : ""} to review.`}
            defaultMessage={`You have {docs} new document${this.context?.documents > 1 ? "s" : ""} to review.`}
            values={{ docs: this.context?.documents }}
          />
        ) : this.props?.notifications ? (
          <FormattedMessage
            id={`You have {notifications} new notification${this.props?.notifications > 1 ? "s" : ""} to review.`}
            defaultMessage={`You have {notifications} new notification${
              this.props?.notifications > 1 ? "s" : ""
            } to review.`}
            values={{
              notifications: this.props?.notifications,
            }}
          />
        ) : (
          <FormattedMessage id="You have no new documents."></FormattedMessage>
        )}
      </div>
    );

    return (
      <Header id="topbar-salutation-container" className="topbarSalutationContainer">
        <div className="topbarSalutation">
          <div className="topbarGreeting">
            <FormattedMessage
              id={`Good ${getGreeting()} {name},`}
              values={{
                name: this.context?.user_info?.first_name
                  ? " " + this.context?.user_info?.first_name
                  : this.context?.user_info?.display_name
                  ? " " + this.context?.user_info?.display_name
                  : this.context?.user_info?.last_name
                  ? " " + this.context?.user_info?.last_name
                  : "",
              }}
              defaultMessage={`Good ${getGreeting()} {name},`}
            />
          </div>
          {displayInfoMessages}
        </div>
        {/* Hidden: to be added in a future release
        <div className="topAdvisor">
          <div className="subComponentContainer">
            <Avatar src={this.props?.img ?? null} icon={this.props?.img ? null : <UserOutlined />} size={55}></Avatar>
            <div className="topbarName">
              <div className="topbarGreeting">{this.props?.advisor ?? "--"}</div>
              <div className="topbarInfoMessages text-capitalize-first"><FormattedMessage id="contact me"/></div>
            </div>
          </div>
        </div> */}
      </Header>
    );
  }
}

export class TopbarUser extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }

  handleLogout = () => {
    this.context.signout_user();
  };
  render() {
    const roles = Object.keys(this.context.roles).map(r => {
      let roleInfo = this.context.roles[r] !== undefined ? this.context.roles[r] : false;

      if (roleInfo === false) return false;
      return (
        <Menu.Item key={r} disabled={r === this.context.active_role} className="text-capitalize">
          <Checkbox
            checked={r === this.context.active_role}
            onChange={() => {
              this.context.changeActiveRole(r);
              if (roleInfo.page !== undefined && r !== this.context.active_role) {
                this.context.navigate(roleInfo.page);
              }
            }}
          >
            {roleInfo.display_name !== undefined
              ? roleInfo.display_name
              : roleInfo.name !== undefined
              ? roleInfo.name
              : r}
          </Checkbox>
        </Menu.Item>
      );
    });

    const menu = (
      <Menu>
        {Object.keys(this.context.roles).length > 1 ? roles : false}
        {Object.keys(this.context.roles).length > 1 ? <Menu.Divider /> : false}
        <Menu.Item onClick={this.props.showSettings}>
          <FormattedMessage id="Settings" />
        </Menu.Item>
        <Menu.Item onClick={this.handleLogout}>
          <FormattedMessage id="Logout" />
        </Menu.Item>
      </Menu>
      
    );

    return (
      <Dropdown
        overlay={menu}
        arrow
        trigger="click"
        placement="bottomRight"
        getPopupContainer={() => document.getElementById("topbar-container")}
        overlayClassName="topbarUserDropdownOverlayContainer"
      >
        <div className="topbarUserIconContainer">
          <Avatar
            icon={<UserOutlined />}
            src={
              this.context.user_info !== undefined &&
              this.context.user_info.photo_url !== undefined &&
              this.context.user_info.photo_url !== null
                ? this.context.user_info.photo_url
                : false
            }
          />
        </div>
      </Dropdown>
    );
  }
}
